<template>
  <v-content v-if="loading">
    <breadcrumbs></breadcrumbs>
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <v-row class="rows center-style">
      <v-flex class="news">
        <v-flex class="new-title">
          {{news.newsTitle}}
        </v-flex>
        <v-flex class="tag">
          发布时间：{{news.createTime}} 热度：{{news.hot}}
        </v-flex>
        <editor v-html="news.newsContent"></editor>
      </v-flex>

      <!-- 右部· -->
      <v-flex class="others">

        <!-- 最新热点 -->
        <v-flex class="div-title">
          <v-flex class="title-text">最新热点</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <v-row style="margin-top:10px"
                 class="re-dian"
                 v-for="(item,i) in newsList"
                 :key="'0'+i">
            <v-flex class="re-dian-image">
              <img class="image"
                   @click="getNews(item.newsId)"
                   :src="item.photo" />
            </v-flex>
            <v-flex class="re-dian-title">
              {{item.newsTitle}}
            </v-flex>
          </v-row>
        </v-flex>

        <!-- 历史档案 -->
        <v-flex class="div-title">
          <v-flex class="title-text">历史档案</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <ul>
            <li v-for="(item,i) in yearList"
                :key="'1'+i">
              <!-- <font>{{item.yearName}}年 ({{item.yearCount}})</font> -->
              <v-row class="year-list">
                <font>{{item.yearName}}年</font>
                <v-spacer></v-spacer>
                <font>({{item.yearCount}})</font>
              </v-row>
            </li>
          </ul>
        </v-flex>

        <!-- 关于我们 -->
        <v-flex class="div-title">
          <v-flex class="title-text">关于我们</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <v-flex>
            <img class="image"
                 @click="$router.push({ name: 'CompanyProfile' })"
                 src="@/images/companyCulture/companyRules/rules2.jpg" />
          </v-flex>

        </v-flex>

      </v-flex>
    </v-row>
  </v-content>
</template>
<script>

import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口
import cookies from 'js-cookie'

export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      isLoading: false,
      //新闻列表
      newsList: [],
      //新闻
      news: {},
      yearList: [],
      userip: ''
    }
  },
  mounted () {
    this.$emit("updateToolbarValue", 2);
    let pageid = this.$route.query.newsId;
    let llid = cookies.get('scchlljl');
    if (llid == null) {
      cookies.set('scchlljl', pageid, { expires: 1 });
      this.updateHot();
    }
    else {
      let ids = llid.split(',');
      let isll = false;
      ids.forEach((item) => {
        if (item == pageid) {
          isll = true;
        }
      }
      );
      if (!isll) {
        cookies.set('scchlljl', llid + "," + pageid, { expires: 1 });
        this.updateHot();
      }
    }
  },
  created () {
    this.yearList = this.$route.query.yearList;
    this.init();
  },
  methods: {
    //初期化
    init () {
      this.getNews(this.$route.query.newsId);
      this.getNewsList();
      this.loading = true;
    },

    updateHot () {
      let newsId = this.$route.query.newsId;
      let hot = this.$route.query.hot;
      hot = hot + 1;
      this.$store
        .dispatch("UpdateHot", { newsId, hot })
        .then(response => {
          console.log(response.data);
        })
        .catch(() => { });
    },

    getNews (id) {
      this.isLoading = true;
      this.$store
        .dispatch("GetNewsContent", id)
        .then(response => {
          this.news = response.data.data;
          this.isLoading = false;
        })
        .catch(() => { });
    },

    getNewsList () {
      this.isLoading = true;
      this.$store
        .dispatch("GetNewsListByPage", {
          //初始页码
          page: 1,
          //每页数量
          pageNum: 5,
          //关键字
          searchWord: null,
        })
        .then(response => {
          this.newsList = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    getImgUrl (str) {
      return require("@/images/text/" + str);
    },

  }
}
</script>

<style scoped>
.rows {
  margin: 70px 0 0 0;
}
.center-style {
  display: flex;
  justify-content: center;
  align-content: center;
}
.tag {
  margin: 0 0 0 300px;
}
.news {
  width: 50%;
  max-width: 600px;
  flex: none;
}

.new-title {
  text-align: center;
  font-size: 25px;
  margin-bottom: 10px;
}
.image {
  width: 100%;
  height: 100%;
}

.year-list {
  margin: 0;
  padding: 0 20px 0 20px;
}

.others {
  width: 400px;
  flex: none;
}
.blue-divider {
  width: 30px;
  border: 2px solid #42a5f6 !important;
  margin: 3px 0 20px 0;
}
.div-title {
  margin-top: 20px;
  padding: 20px;
}
.title-text {
  font-size: 20px;
}
.news-content {
  margin: 10px;
  font-size: 14px;
  color: gray;
}
.re-dian {
  margin: 0;
  height: 80px;
  flex: none;
}
.re-dian-image {
  width: 110px;
  height: 80px;
}
.re-dian-title {
  width: calc(100% - 120px);
  margin-left: 10px;
  font-size: 14px;
  color: gray;
  overflow: hidden;
}
</style>